<div class="session-conflict-backdrop">
  <div
    class="session-conflict"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="session-conflict-title"
    aria-describedby="session-conflict-message"
  >
    <div class="dialog-header">
      <h2 id="session-conflict-title" class="dialog-title">{{ title() }}</h2>
    </div>
    <p id="session-conflict-message" class="session-conflict-message">
      {{ message() }}
    </p>
    @if (onLobby()) {
      <p class="session-conflict-hint">
        Or close this tab to keep playing in the other one.
      </p>
    }
    <div class="dialog-actions">
      @if (!onLobby()) {
        <button
          type="button"
          class="secondary-btn"
          [disabled]="busy()"
          (click)="backToLobby.emit()"
        >
          Back to lobby
        </button>
      }
      <button
        #playButton
        type="button"
        class="primary-btn"
        [disabled]="busy()"
        [attr.aria-busy]="busy()"
        (click)="playHere.emit()"
      >
        {{ busy() ? 'Moving…' : 'Play here instead' }}
      </button>
    </div>
  </div>
</div>
